import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React__default, { useState, useRef, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { classnames } from '../../../utils/classnames.js';
import './ImagePreview.scss.js';
import ArrowsRenew from '../../../assets/icons/resultDir/ArrowsRenew.js';
import AllReduce from '../../../assets/icons/resultDir/AllReduce.js';
import AllAdd from '../../../assets/icons/resultDir/AllAdd.js';
import AllClose from '../../../assets/icons/resultDir/AllClose.js';
import ArrowsChevronLeft from '../../../assets/icons/resultDir/ArrowsChevronLeft.js';
import ArrowsChevronRight from '../../../assets/icons/resultDir/ArrowsChevronRight.js';

var ImagePreview = function ImagePreview(_ref) {
  var images = _ref.images,
      onClose = _ref.onClose;
  var initMatrix = 'matrix(1,0,0,1,0,0)';

  var _useState = useState(images[0]),
      _useState2 = _slicedToArray(_useState, 2),
      currentImage = _useState2[0],
      setCurrentImage = _useState2[1];

  var zoomRef = useRef(null);
  var deltaRef = useRef(1);
  var deltaXRef = useRef(0);
  var deltaYRef = useRef(0);
  var screenRef = useRef(null);

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      previewIndex = _useState4[0],
      setPreviewIndex = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      isDisabled = _useState6[0],
      setIsDisabled = _useState6[1];

  var unFlatArray = function unFlatArray(arr, sliceNumber) {
    var result = [];

    for (var s = 0, e = sliceNumber; s < arr.length; s += sliceNumber, e += sliceNumber) {
      result.push(arr.slice(s, e));
    }

    return result;
  };

  var previewArray = useMemo(function () {
    return unFlatArray(images, 10);
  }, [images]);
  var visibleValues = useRef({
    minIndex: 0,
    maxIndex: 9
  });

  var zoomInHandler = function zoomInHandler() {
    deltaRef.current += 0.5;
    setIsDisabled(false);
    zoomRef.current.classList.remove('move');
    zoomRef.current.style.transform = "matrix(".concat(deltaRef.current, ",0,0,").concat(deltaRef.current, ",").concat(deltaXRef.current, ",").concat(deltaYRef.current, ")");
  };

  var zoomOutHandler = function zoomOutHandler() {
    if (deltaRef.current !== 1) {
      deltaRef.current -= 0.5;
    }

    if (deltaRef.current === 1) {
      setIsDisabled(true);
      setInit();
    }

    zoomRef.current.classList.remove('move');
    zoomRef.current.style.transform = "matrix(".concat(deltaRef.current, ",0,0,").concat(deltaRef.current, ",").concat(deltaXRef.current, ",").concat(deltaYRef.current, ")");
  };

  var zoomInitHandler = function zoomInitHandler() {
    setIsDisabled(true);
    setInit();
  };

  var closeHandler = function closeHandler() {
    zoomRef.current.style.transform = initMatrix;
    onClose();
  };

  var onMoveHandler = function onMoveHandler(e) {
    if (deltaRef.current > 1) {
      zoomRef.current.classList.add('move');
    }
  };

  var onMouseMoveHandler = function onMouseMoveHandler(e) {
    if (zoomRef.current.classList[0] === 'move') {
      zoomRef.current.style.transform = "matrix(".concat(deltaRef.current, ",0,0,").concat(deltaRef.current, ",").concat(deltaXRef.current += e.movementX, ",").concat(deltaYRef.current += e.movementY, ")");
    }
  };

  var onMoveEndHandler = function onMoveEndHandler() {
    zoomRef.current.classList.remove('move');
  };

  var topNavigation = useMemo(function () {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "rf-image-preview__top-navigation",
      "data-v-6e52f9c7": ""
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "top-navigation__zoom",
      "data-v-6e52f9c7": ""
    }, /*#__PURE__*/React__default.createElement("div", {
      "aria-label": "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C",
      onClick: zoomInitHandler,
      className: classnames('top-navigation__button', isDisabled ? 'top-navigation__button--disabled' : ''),
      "data-v-6e52f9c7": ""
    }, /*#__PURE__*/React__default.createElement(ArrowsRenew, {
      "data-v-6e52f9c7": ""
    })), /*#__PURE__*/React__default.createElement("div", {
      "aria-label": "\u041E\u0442\u0434\u0430\u043B\u0438\u0442\u044C",
      onClick: zoomOutHandler,
      className: classnames('top-navigation__button', isDisabled ? 'top-navigation__button--disabled' : ''),
      "data-v-6e52f9c7": ""
    }, /*#__PURE__*/React__default.createElement(AllReduce, {
      "data-v-6e52f9c7": ""
    })), /*#__PURE__*/React__default.createElement("div", {
      "aria-label": "\u041F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u044C",
      onClick: zoomInHandler,
      className: "top-navigation__button",
      "data-v-6e52f9c7": ""
    }, /*#__PURE__*/React__default.createElement(AllAdd, {
      "data-v-6e52f9c7": ""
    }))), /*#__PURE__*/React__default.createElement("div", {
      "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
      onClick: closeHandler,
      className: "top-navigation__button",
      "data-v-6e52f9c7": ""
    }, /*#__PURE__*/React__default.createElement(AllClose, {
      "data-v-6e52f9c7": ""
    })));
  }, [isDisabled]);

  var imageHandler = function imageHandler(src) {
    return function () {
      setInit();
      setCurrentImage(src);
    };
  };

  var currentIndex = useMemo(function () {
    return images.findIndex(function (image) {
      return image === currentImage;
    });
  }, [currentImage]);

  var setInit = function setInit() {
    deltaRef.current = 1;
    deltaYRef.current = 0;
    deltaXRef.current = 0;
    zoomRef.current.style.transform = initMatrix;
    zoomRef.current.classList.remove('move');
  };

  var prevImageHandler = function prevImageHandler() {
    setInit();
    setIsDisabled(true);
    setCurrentImage(images[currentIndex - 1]);
    setPreviewIndex(Math.floor(currentIndex / 10));

    if (currentIndex % 10 === 0) {
      setPreviewIndex(previewIndex - 1);
    } else {
      if (visibleValues.current.minIndex > previewIndex) {
        visibleValues.current = {
          minIndex: visibleValues.current.minIndex - 1,
          maxIndex: visibleValues.current.maxIndex - 1
        };
      }
    }
  };

  var nextImageHandler = function nextImageHandler() {
    setIsDisabled(true);
    setInit();
    setCurrentImage(images[currentIndex + 1]);
    setPreviewIndex(Math.floor(currentIndex / 10));

    if ((currentIndex + 1) % 10 === 0) {
      setPreviewIndex(previewIndex + 1);
    } else {
      if (visibleValues.current.maxIndex <= previewIndex) {
        visibleValues.current = {
          minIndex: visibleValues.current.minIndex + 1,
          maxIndex: visibleValues.current.maxIndex + 1
        };
      }
    }
  };

  var bottomPrevHandler = function bottomPrevHandler() {
    setPreviewIndex(previewIndex - 1);
  };

  var bottomNextHandler = function bottomNextHandler() {
    setPreviewIndex(previewIndex + 1);
  };

  var noop = useMemo(function () {
    return function () {};
  }, []);
  var bottomNavigationMenu = useMemo(function () {
    return images.length > 1 ? /*#__PURE__*/React__default.createElement("div", {
      "data-testid": "bottom-chevron-left",
      className: classnames('rf-image-preview__bottom-navigation', images.length > 10 ? 'rf-image-preview__bottom-navigation--big' : '', isDisabled ? '' : 'bottom-navigation--disabled'),
      "data-v-6e52f9c7": ""
    }, images.length > 10 ? /*#__PURE__*/React__default.createElement("div", {
      "aria-label": "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
      onClick: previewIndex > 0 ? bottomPrevHandler : noop,
      className: classnames('bottom-navigation__left', previewIndex > 0 ? '' : 'button__disabled'),
      "data-v-6e52f9c7": ""
    }, /*#__PURE__*/React__default.createElement(ArrowsChevronLeft, {
      "data-v-6e52f9c7": ""
    })) : null, previewArray[previewIndex].map(function (image, index) {
      var realIndex = index + 10 * previewIndex;

      if (visibleValues.current.minIndex <= index && visibleValues.current.maxIndex >= index) {
        return /*#__PURE__*/React__default.createElement("div", {
          role: "presentation-image--".concat(index),
          "data-testid": "bottom__image--".concat(index),
          onClick: imageHandler(image),
          key: image,
          className: classnames('bottom-navigation__item', currentIndex === realIndex ? 'item__active' : ''),
          "data-v-6e52f9c7": ""
        }, /*#__PURE__*/React__default.createElement("img", {
          src: image,
          alt: image,
          "data-v-6e52f9c7": ""
        }));
      }

      return null;
    }), images.length > 10 ? /*#__PURE__*/React__default.createElement("div", {
      "data-testid": "bottom-chevron-right",
      "aria-label": "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
      onClick: previewArray.length - 1 > previewIndex ? bottomNextHandler : noop,
      className: classnames('bottom-navigation__right', previewArray.length - 1 > previewIndex ? '' : 'button__disabled'),
      "data-v-6e52f9c7": ""
    }, /*#__PURE__*/React__default.createElement(ArrowsChevronRight, {
      "data-v-6e52f9c7": ""
    })) : null) : null;
  }, [currentIndex, previewIndex, isDisabled]);
  var labelCountComponent = useMemo(function () {
    return images.length > 10 ? isDisabled ? /*#__PURE__*/React__default.createElement("div", {
      className: "rf-label-count__component",
      "data-v-6e52f9c7": ""
    }, /*#__PURE__*/React__default.createElement("label", {
      "data-testid": "label-count-test",
      "data-v-6e52f9c7": ""
    }, " ", currentIndex + 1 + ' / ' + images.length)) : null : null;
  }, [currentIndex, images.length, isDisabled]);
  var navigationControl = useMemo(function () {
    return images.length > 1 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      "aria-label": "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0430\u044F \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0430",
      onClick: currentIndex ? prevImageHandler : noop,
      className: classnames('navigation-control__left', !currentIndex ? 'button__disabled' : ''),
      "data-v-6e52f9c7": ""
    }, /*#__PURE__*/React__default.createElement(ArrowsChevronLeft, {
      "data-v-6e52f9c7": ""
    })), /*#__PURE__*/React__default.createElement("div", {
      "aria-label": "\u0421\u043B\u0443\u0434\u0443\u044E\u0449\u0430\u044F \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0430",
      onClick: currentIndex + 1 !== images.length ? nextImageHandler : noop,
      className: classnames('navigation-control__right', currentIndex + 1 === images.length ? 'button__disabled' : ''),
      "data-v-6e52f9c7": ""
    }, /*#__PURE__*/React__default.createElement(ArrowsChevronRight, {
      "data-v-6e52f9c7": ""
    }))) : null;
  }, [images, currentIndex]);
  var imageContent = useMemo(function () {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "rf-image-preview__full-image ".concat(images.length < 10 ? 'single__full-image' : ''),
      "data-v-6e52f9c7": ""
    }, /*#__PURE__*/React__default.createElement("img", {
      role: "presentation-image",
      draggable: false,
      onMouseUp: onMoveEndHandler,
      onMouseDown: onMoveHandler,
      onMouseMove: onMouseMoveHandler,
      onMouseOut: onMoveEndHandler,
      ref: zoomRef,
      src: currentImage,
      alt: currentImage,
      "data-v-6e52f9c7": ""
    }));
  }, [currentImage]);
  var preview = /*#__PURE__*/React__default.createElement("div", {
    ref: screenRef,
    className: "rf-image-preview",
    "data-v-6e52f9c7": ""
  }, topNavigation, imageContent, images.length > 1 ? /*#__PURE__*/React__default.createElement("div", {
    className: "rf-naviation-bottom__container",
    "data-v-6e52f9c7": ""
  }, labelCountComponent, bottomNavigationMenu) : null, navigationControl);
  return /*#__PURE__*/createPortal(preview, document.body);
};

export { ImagePreview as default };
